import styles from './Pages.module.css';

export default function Sobre(){
	return(
		<div className={styles.container}>
			<div className={styles.containerHeader}>
				<h1>Sobre</h1>
			</div>
			<div className={styles.containerContent} style={{overflowY: 'hidden'}}>
				<div className={styles.centerContent}>
					<p>O módulo <b>MinhaAju: Vegetação</b> se trata de uma ferramenta que possibilita a visualização de alguns aspectos ambientais da capital sergipana, por meio de um mapa interativo.</p>
					<p>O mesmo faz parte do MinhaAju, aplicação que visa exibir, de maneira descomplicada, informações provindas dos dados abertos da cidade de Aracaju-SE por meio de uma abordagem visual.</p>
					<p>Para o seu desenvolvimento, utilizou-se as seguintes tecnologias:
					<ul className={styles.ulTech}>
						<li>React <i class="fa-brands fa-react"></i></li>
						<li>Javascript <i class="fa-brands fa-square-js"></i></li>
						<li>CSS <i class="fa-brands fa-css3"></i></li>
						<li>HTML <i class="fa-brands fa-html5"></i></li>
					</ul>
					</p>
					<h4 style={{textAlign: 'center', fontSize: 'calc(6px + 2vmin)'}}>Entre em contato:</h4>
					<div className={styles.containerContact}>
						<div className={styles.centerContent}><a href="https://www.instagram.com/_gabe.cc/" target='_blank' rel='noopener noreferrer'><i class="fa-brands fa-instagram"><p>Instagram</p></i></a></div>
						<div className={styles.centerContent}><a href="https://www.linkedin.com/in/gabe-cc/" target='_blank' rel='noopener noreferrer'><i class="fa-brands fa-linkedin"><p>Linkedin</p></i></a></div>
						<div className={styles.centerContent}><a href="https://github.com/G4bzz/" target='_blank' rel='noopener noreferrer'><i class="fa-brands fa-github"><p>github</p></i></a></div>
						<div className={styles.centerContent}><a href="mailto:g4briel720@academico.ufs.br" target='_blank' rel='noopener noreferrer'><i class="fa-solid fa-envelope"><p>Email</p></i></a></div>
					</div>
				</div>
			</div>
		</div>
	)
}